import { lazy } from 'react';

const OwnerOverviewPage = lazy(() => import('../pages/OwnerOverview.page'));
const PlansListPage = lazy(() => import('../pages/PlansList.page'));
const PlanFormPage = lazy(() => import('../pages/PlanForm.page'));
const TenantFormPage = lazy(() => import('../pages/TenantForm.page'));
const TenantsListPage = lazy(() => import('../pages/TenantsList.page'));
const UpgradeRequestsPage = lazy(() => import('../pages/UpgradeRequests.page'));
const PlatformUsersPage = lazy(() => import('../pages/PlatformUsers.page'));
const PlatformSettingsPage = lazy(() => import('../pages/PlatformSettings.page'));

const ownerRoute = {
    layout: 'default' as const,
    isAuthReq: true,
    ownerOnly: true,
};

export const SubscriptionsRoutes = [
    {
        path: 'subscriptions',
        children: [
            { index: true, element: <OwnerOverviewPage />, ...ownerRoute },
            { path: 'plans', element: <PlansListPage />, ...ownerRoute },
            { path: 'plans/add', element: <PlanFormPage />, ...ownerRoute },
            { path: 'plans/:id/edit', element: <PlanFormPage />, ...ownerRoute },
            { path: 'tenants', element: <TenantsListPage />, ...ownerRoute },
            { path: 'tenants/add', element: <TenantFormPage />, ...ownerRoute },
            { path: 'users', element: <PlatformUsersPage />, ...ownerRoute },
            { path: 'requests', element: <UpgradeRequestsPage />, ...ownerRoute },
            { path: 'platform-settings', element: <PlatformSettingsPage />, ...ownerRoute },
        ],
    },
];
